import React from 'react'
import { Input } from '@/components/ui/input'
import { Send } from 'lucide-react'
import { PlayButton } from '../PlayButton/PlayButton'

interface ChatInputBoxProps {
  textInput: string
  setTextInput: (value: string) => void
  onSend: () => void
  isEnabled: boolean
  isAudioPlaying: boolean
  isPlaybackPaused: boolean
  onPause: () => void
  onResume: () => void
}

export const ChatInputBox: React.FC<ChatInputBoxProps> = ({
  textInput,
  setTextInput,
  onSend,
  isEnabled,
  isAudioPlaying,
  isPlaybackPaused,
  onPause,
  onResume,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && isEnabled) {
      onSend()
    }
  }

  const renderButton = () => {
    if (isAudioPlaying || isPlaybackPaused) {
      return (
        <PlayButton
          isPaused={false}
          isAudioPlaying={isAudioPlaying}
          isUserSpeaking={false}
          onClick={isPlaybackPaused ? onResume : onPause}
          isPlaybackPaused={isPlaybackPaused}
          className="w-10 h-10"
        />
      )
    }
    return (
      <button
        onClick={onSend}
        disabled={!isEnabled || !textInput?.trim()}
        className="p-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Send size={24} />
      </button>
    )
  }

  return (
    <div className="flex items-center gap-2 mt-4 max-w-[530px] mx-auto sm:px-4">
      <Input
        name={'user-input'}
        value={textInput}
        onChange={(e) => setTextInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={'Type your message...'}
        className="flex-1"
      />
      {renderButton()}
    </div>
  )
}
